module.exports = __webpack_public_path__ + "static/media/customer-mondelex.d590ae34.png";